export const defaultStyle = {
    wrapper: "relative",
    slideItem: "relative w-full h-[620px] md:h-[680px] xlg:h-[780px]",
    overlay: "absolute w-full h-full left-0 top-0 z-[3] flex justify-center items-center",
    bg: "object-cover w-full h-full",
}
